import React from 'react';
import { Dialog } from 'primereact/dialog';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from 'primereact/button';
import useNewBusinessModelAccountCheck from '../../../../../hooks/useNewBusinessModelAccountCheck';

const messages = defineMessages({
  notice: {
    id: 'super-link-notice.notice',
    defaultMessage: 'Notice',
  },
  firstParagraph: {
    id: 'survey-import-notice.first-paragraph',
    defaultMessage:
      'This SuperSurvey required {numberOfInternalRespondentsOfImport} new Internal Respondents. However, as you only have {numberOfInternalRespondentsThatCanBeAdded} Internal Respondents left you need to:',
  },
  secondParagraph: {
    id: 'survey-import-notice.second-paragraph',
    defaultMessage: 'Reduce the number of surveys or the number of participants in the surveys, or',
  },
  thirdParagraph: {
    id: 'survey-import-notice.third-paragraph',
    defaultMessage:
      'Release Internal Respondents by changing some of your existing Internal Respondents to External Respondents or by deleting some of your existing Internal Respondents, or',
  },
  fourthParagraph: {
    id: 'super-link-notice.fourth-paragraph',
    defaultMessage: 'Upgrade your NoLimit subscription to include more Internal Respondents.',
  },
  fifthParagraph: {
    id: 'super-link-notice.fifth-paragraph',
    defaultMessage: 'Then, please import the SuperSurvey again.',
  },
  gotIt: {
    id: 'user-notification-dialog.button',
    defaultMessage: 'Got it',
  },
});

const SurveyImportNotice = ({
  numberOfInternalRespondentsOfImport,
  numberOfInternalRespondentsThatCanBeAdded,
  hideDialog,
}) => {
  const { formatMessage } = useIntl();

  const { isNewBusinessModelAccount } = useNewBusinessModelAccountCheck();
  const dialogVisible = numberOfInternalRespondentsOfImport > 0 && numberOfInternalRespondentsThatCanBeAdded > 0;

  return (
    <Dialog visible={dialogVisible} header={formatMessage(messages.notice)} closable={false} onHide={hideDialog}>
      <p>
        <strong>
          {formatMessage(messages.firstParagraph, {
            numberOfInternalRespondentsOfImport,
            numberOfInternalRespondentsThatCanBeAdded,
          })}
        </strong>
      </p>
      <ul>
        <li>
          <strong>{formatMessage(messages.secondParagraph)}</strong>
        </li>
        <li>
          <strong>{formatMessage(messages.thirdParagraph)}</strong>
        </li>
        {isNewBusinessModelAccount && (
          <li>
            <strong>{formatMessage(messages.fourthParagraph)}</strong>
          </li>
        )}
      </ul>
      <p>
        <strong>{formatMessage(messages.fifthParagraph)}</strong>
      </p>
      <div className="flex-center">
        <Button
          type="button"
          className="p-button-primary"
          onClick={hideDialog}
          label={`${formatMessage(messages.gotIt)} !`}
        />
      </div>
    </Dialog>
  );
};

export default SurveyImportNotice;
